export const getEmailShareLink = ({ subject, body }) => {
    // Use encodeURIComponent instead of URLSearchParams for spaced to encode to %20 instead of +
    const encodedSubject = encodeURIComponent(subject);
    const encodedBody = encodeURIComponent(body.replace(/\\n/g, '\r\n'));
    return `mailto:?${
        subject ? `subject=${encodedSubject}&` : ''
    }body=${encodedBody}`;
};

export const getFacebookShareLink = ({ url }) => {
    const link = new URL('https://www.facebook.com/sharer/sharer.php');
    link.searchParams.set('u', url);
    return link.toString();
};

export const getPinterestShareLink = ({ url, description, imageUrl }) => {
    const link = new URL('https://pinterest.com/pin/create/button/');
    link.searchParams.set('url', url);
    link.searchParams.set('description', description);
    link.searchParams.set('media', imageUrl);
    return link.toString();
};

export const getSmsShareLink = ({ number, body }) => {
    const encodedBody = encodeURIComponent(body);
    return number
        ? `sms:${number};?&body=${encodedBody}`
        : `sms:?&body=${encodedBody}`;
};
